module.exports = __webpack_public_path__ + "img/icon-md-mood-07.112aa9ef.svg";